import { fromJS } from 'immutable';
import { RESET_STORE } from 'containers/LoginPage/constants';
import {
  RESET_STORE_CLAIM,
  SET_CLAIM_RECAP,
  SET_CORPOREAL_LAWYERS,
  SET_OPENED_CLAIM,
  REQUEST_SET_SAGIS_CLAIM,
} from 'containers/RecapManagerPage/constants';
import { SET_EXPERTS_USERS } from 'containers/CourtManagerLegalProceedings/constants';

export interface SetClaimAction {
  type: string;
  claim: any;
  payload?: { data: [] };
}

const initialState = fromJS({
  claimRecap: {},
  corporealLawyers: [],
  openedClaim: {},
  corporealExperts: [],
  sagisClaim: {},
});

const recapManagerPageReducer = (
  state = initialState,
  action: SetClaimAction,
) => {
  switch (action.type) {
    case SET_CLAIM_RECAP:
      return state.set('claimRecap', fromJS(action.claim));
    case SET_CORPOREAL_LAWYERS:
      return state.set('corporealLawyers', fromJS(action.payload?.data));
    case SET_EXPERTS_USERS:
      return state.set('corporealExperts', fromJS(action.payload?.data));
    case RESET_STORE:
      return initialState;
    case SET_OPENED_CLAIM:
      return state.set('openedClaim', fromJS(action.payload));
    case REQUEST_SET_SAGIS_CLAIM:
      return state.set('sagisClaim', fromJS(action.payload?.data));
    case RESET_STORE_CLAIM:
      return initialState;
    default:
      return state;
  }
};
export default recapManagerPageReducer;
